import { Link } from "react-router-dom";

function NavBarGeral() {
  return (
    <>
      <nav className="navbar navbar-dark navbar-theme-primary px-4 col-12 d-lg-none">
        <Link className="navbar-brand me-lg-5" to="/dashboard">
          <img
            className="navbar-brand-dark"
            src="/img/brand/logo_dfsi.jpg"
            alt="app logo"
          />
        </Link>
        <div className="d-flex align-items-center">
          <button
            className="navbar-toggler d-lg-none collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarMenuGeral"
            aria-controls="sidebarMenuGeral"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </nav>
    </>
  );
}

export default NavBarGeral;
